import watstreet from "../../assets/WATSTREET.jpg"

const experiences = [
    {
      title: "Software Engineering Intern",
      company_name: "Regional Municipality of York",
      icon: watstreet,
      iconBg: "#383E56",
      date: "May 2024 - Present",
      points: [
        "Building internal tools (2000+ users) and web apps with Azure, React, NextJS, C# and Power Platform"
      ],
    },
    {
      title: "Software Research Assistant",
      company_name: "University of Waterloo - ArGans Lab",
      icon: watstreet,
      iconBg: "#E6DEDD",
      date: "Jan 2024 - Present",
      points: [
        "Working under an NDA - Working on drug discovery and internal research tools under the guidance of Dr. Aravindhan Ganesan"
      ],
    },
    {
      title: "Full Stack Developer",
      company_name: "Wat Street",
      icon: watstreet,
      iconBg: "#383E56",
      date: "Sept 2023 - April 2024",
      points: [
        "Responsible for the website and algorithmic trading dashboard - Reduced render time by 12% as measured by React Dev Tools and Lighthouse"
      ],
    },
    {
      title: "Freelance Frontend Web Developer",
      company_name: "Fiver",
      icon: watstreet,
      iconBg: "#E6DEDD",
      date: "Feb 2023 - Aug 2023",
      points: [
        "Produced websites and web apps for clients on Fiverr - Achieved 4.7/5.0 star rating"
      ],
    },
    {
      title: "Mathematics Tutor",
      company_name: "Math2Success",
      icon: watstreet,
      iconBg: "#383E56",
      date: "May 2022 - Jul 2023",
      points: [
        "Taught mathematics to students from grades 11 and 12 - Received immensly position reviews with a 96% satisfaction rate",
      ],
    },
  ];

  export { experiences }